import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'split'
})
export class SplitPipe implements PipeTransform {

  transform(str: string, char?: string, at?: number): any {

    return str?.split(char)?.[at];
  }


}
